import React from "react"

export default function Hero() {
    return (
        <section className="hero">
            <h3 className="hero--tophead">A Modern Pony Express</h3>
            <h4 className="hero--bottomhead">Delivery Solution</h4>
            <p className="hero--text">The Pony Express is well known for its dedication to the art of delivery. Luna builds upon that respect, loyalty, and pure grit to ensure your deliveries are quick, careful, and overall an optimal experience - come snow, rain, sleet, or hail.</p>
        </section>
    )
}